import React from 'react';
import { Container, Card, Button } from 'react-bootstrap';
import { theme } from '../theme';

const ACCOUNTSNEW_URL = process.env.REACT_APP_APP_INK_URL || 'https://app.ink-it.ink/';

const Login = () => {
    return (
        <Container className="login-page d-flex justify-content-center align-items-center" style={{ minHeight: '100vh' }}>
            <Card style={{ width: '400px' }}>
                <Card.Body className="text-center">
                    <div className="mb-4">
                        <i className="fa fa-lock" style={{ fontSize: '48px', color: theme.secondary }}></i>
                    </div>
                    <Card.Title className="mb-3">Acceso a Admin</Card.Title>
                    <Card.Text className="text-muted mb-4">
                        Para acceder a esta aplicación, debes iniciar sesión desde el sistema principal de Ink It.
                    </Card.Text>
                    <Button
                        variant="primary"
                        size="lg"
                        href={`${ACCOUNTSNEW_URL}`}
                        className="w-100 login-cta"
                    >
                        <i className="fa fa-sign-in me-2"></i>
                        Ir a Ink It
                    </Button>
                    <div className="mt-3">
                        <small className="text-muted">
                            Una vez autenticado, haz clic en "Admin React" en el menú principal.
                        </small>
                    </div>
                </Card.Body>
            </Card>
        </Container>
    );
};

export default Login;
